// Browser-compatible environment variables
interface BrowserEnv {
  REACT_APP_PRINT_FUNCTION_URL?: string;
}

// Default environment variables
const defaultEnv: BrowserEnv = {
  REACT_APP_PRINT_FUNCTION_URL: 'https://us-central1-fllboats.cloudfunctions.net/sendPrintJob'
};

// Export a getter function that works in browser environments
export const getEnv = (key: keyof BrowserEnv): string | undefined => {
  // Check if window.__env exists and has the key
  const windowEnv = typeof window !== 'undefined' && 
                   (window as any).__env && 
                   (window as any).__env[key];
  
  if (windowEnv) return windowEnv;
  
  // Fall back to default values
  return defaultEnv[key];
}; 